import React, { useEffect, useContext } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDDropdown from 'components/MDDropdown'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import ZuDataTable from 'components/ZeroUno/ZuDataTable'

// zerouno
import deviceCustomerService from 'services/device-customer.service'
import { Link, useParams } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import RabbitContext from 'context/rabbit.js'
import RegistryNav from './RegistryNav'
import { config } from 'variables/Config'
import utils from 'utils/utils'

export default function DeviceCustomerTable() {
  const { idRegistry } = useParams()
  const [objId, setObjId] = React.useState(0)
  const [objects, setObjects] = React.useState([])
  const [showSnackbar, setShowSnackbar] = React.useState({
    sh: false,
    msg: '',
    color: 'success'
  })
  const [openConfirm, setOpenConfirm] = React.useState(false)
  const [openMenuActions, setOpenMenuActions] = React.useState(false)

  useEffect(() => {
    fetchObjects()
  }, [])

  const fetchObjects = () => {
    deviceCustomerService.findByRegistry(idRegistry).then(
      response => {
        setObjects(response.data)
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    deviceCustomerService.remove(idRegistry, objId).then(
      response => {
        setShowSnackbar({
          sh: true,
          msg: 'operazione effettuata con successo',
          color: 'success'
        })
        fetchObjects()
      },
      error => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  const columns = [
    {
      header: 'Prodotto',
      accessorKey: 'device.model.name',
      width: 150
    },
    {
      header: 'SN',
      accessorKey: 'device.serial',
      width: 150
    },
    {
      header: 'MAC',
      accessorKey: 'device.macAddress',
      width: 150
    },
    ...(!idRegistry
      ? [
        {
          header: 'cliente',
          accessorFn: d => d.registry.businessName.trim()
        }
      ]
      : []),
    {
      header: 'Indirizzo',
      accessorFn: d => {
        return `${d.address.address} ${d.address.civicNumber} - ${d.address.city}`
      }
    },
    {
      header: 'Data attivazione',
      accessorFn: d => {
        return utils.formatDate(d.activationDate, 'dd/MM/yyyy')
      }
    },
    {
      header: 'Data disattivazione',
      accessorFn: d => {
        return d.disactivationDate
          ? utils.formatDate(d.disactivationDate, 'dd/MM/yyyy')
          : ''
      }
    },
    {
      header: 'azioni',
      enableSorting: false,
      enableColumnFilter: false,
      width: 100,
      Cell: ({ row }) => (
        <Grid container spacing={1}>
          <Grid item>
            {row.original.file && (
              <MDButton
                color='primary'
                size='small'
                iconOnly
                href={`${config.SERVER_URL}/registries/${idRegistry}/devicecustomers/download/${row.original.file}`}
                target='_blank'
              >
                <Icon>download</Icon>
              </MDButton>
            )}
          </Grid>
          <Grid item>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={`/registries/${idRegistry}/device-customers/${row.original.id}`}
            >
              <Icon>edit</Icon>
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              iconOnly
              color='error'
              size='small'
              onClick={() => {
                setObjId(row.original.id)
                setOpenConfirm(true)
              }}
            >
              <Icon>delete</Icon>
            </MDButton>
          </Grid>
        </Grid>
      )
    }
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={10}>
            <Card>
              <ZUTitleForm bgColor='warning' title='Prodotti / Servizi' icon='settings' />

              <MDBox p={3} lineHeight={1}>
                <MDButton
                  color='info'
                  component={Link}
                  to={`/registries/${idRegistry}/device-customers/new`}
                  m={1}
                >
                  assegna
                </MDButton>
              </MDBox>
              <ZuDataTable table={{ columns: columns, rows: objects }} />
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
            <RegistryNav id={idRegistry} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione assegnazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>
  )
}
